import $ from 'jquery'
import _ from 'lodash'
import View from 'view/view'
import windowView from 'shared/view/window'

const CollapsibleTextView = View.extend({
    el: '.js-collapsible-text',
    originalHeight: 0,

    defaultOptions() {
        return {
            extraElementsToCollapseSelector: '.js-hide-on-description-collapse',
            extraElementsStartHidden: false,
            deepLink: false,
            collapseHeight: 60,
            collapseSpeed: 500,
            collapseCompletely: false,
            expandText: 'Read more',
            collapseText: 'Read less',

            // additional content size related options
            contentLength: null,
            collapseContentSize: null,
            minHiddenContentLength: 100,

            css: {
                footerClass: 'js-collapsibleText-footer collapsibleText__footer',
                buttonClass: 'collapsibleText__toggleButton',
                expandClass: 'collapsibleText__expand',
                collapseClass: 'collapsibleText__collapse',
            },

            state: {
                active: 'is-active',
                collapsed: 'is-collapsed',
                expanded: 'is-expanded',
                collapseCompletely: 'is-collapse-completely',
                scrollTop: 0,
            },
        }
    },

    initialize(options) {
        _.bindAll(this, _.functionsIn(this))

        const overrides = this.$el.data() || {}

        if (options.collapseCompletely || overrides.collapseCompletely) {
            overrides.collapseHeight = 0
        }

        this.options = this.pickOptions(options, this.defaultOptions, overrides)

        // Collapse completely mode
        if (this.options.collapseCompletely) {
            this.$el.addClass(this.options.state.collapseCompletely)
        }

        this.setOriginalHeight(false)
        this.activate()
        this.subscribe()
    },

    setOriginalHeight(setTemporaryHeight) {
        const temporaryHeight = this.$el.height()
        this.originalHeight = this.$el.css({ height: 'auto' }).height()

        if (setTemporaryHeight) {
            this.$el.css({
                height: temporaryHeight,
            })
        }
    },

    activate() {
        const { collapseHeight, contentLength, minHiddenContentLength, collapseContentSize, deepLink } = this.options

        if (
            (this.originalHeight > collapseHeight || contentLength - minHiddenContentLength >= collapseContentSize) &&
            !deepLink
        ) {
            this.$el.css({ height: collapseHeight }).addClass(this.options.state.active)

            this.appendFooter()
            this.appendButton()

            // Extra info starts off hidden
            if (this.options.extraElementsStartHidden) {
                this.toggleExtraInfo(true)
            }
        } else if (deepLink) {
            this.$el.addClass(this.options.state.active).addClass(this.options.state.expanded)

            this.appendFooter()
            this.appendButton()
        }
    },

    subscribe() {
        if (this.$el.hasClass(this.options.state.active)) {
            this.$footer.on('click', _.throttle(this.handleToggle))
        }
    },

    appendFooter() {
        const footer = '<div />'
        let footerState = this.options.state.collapsed

        if (this.options.deepLink) {
            footerState = this.options.state.expanded
        }

        this.$footer = $(footer).addClass([this.options.css.footerClass, footerState].join(' '))
        this.$el.after(this.$footer)
    },

    appendButton() {
        const button =
            `${'<a href="javascript:void(0);">' + '<span class="'}${this.options.css.expandClass}">${
                this.options.expandText
            }</span>` +
            `<span class="${this.options.css.collapseClass}">${this.options.collapseText}</span>` +
            '</a>'

        this.$button = $(button).addClass([this.options.css.buttonClass].join(' '))
        this.$footer.append(this.$button)
    },

    handleToggle(evt) {
        const that = this
        let height = this.options.collapseHeight

        evt.preventDefault()
        this.setOriginalHeight(true)
        this.toggleExtraInfo()

        if (this.$footer.hasClass(this.options.state.collapsed)) {
            height = this.originalHeight
            this.options.state.scrollTop = windowView.scrollTop()
        } else {
            windowView.scrollTop(this.options.state.scrollTop)
        }

        this.$el.stop().animate({ height }, this.options.collapseSpeed, () => {
            that.$el.toggleClass(that.options.state.expanded)
            if (that.$footer.hasClass(that.options.state.expanded)) {
                that.$el.css({ height: 'auto' })
            }
        })

        this.$footer.toggleClass([this.options.state.collapsed, this.options.state.expanded].join(' '))
    },

    toggleExtraInfo(hide) {
        const $extraInfo = $(this.options.extraElementsToCollapseSelector)
        if (hide) {
            $extraInfo.hide()
        } else {
            $extraInfo.stop().slideToggle(this.options.collapseSpeed)
        }
    },
})

export default CollapsibleTextView
